/* eslint-disable import/prefer-default-export */
export const filterOptionsBySearch = (options, searchQuery) => {
  if (!searchQuery.trim()) return options

  const lowerQuery = searchQuery.toLowerCase()
  return options.filter((option) => option.name?.toLowerCase().includes(lowerQuery))
}

export const filterOptionsForViewSelected = (options, selectedValues) =>
  options.filter((option) => selectedValues.includes(option.value))
